import School from "./School";
export default School;
